import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info';

interface SnackbarState {
    open: boolean;
    message: string;
    severity: SnackbarSeverity;
}

const initialState: SnackbarState = {
    open: false,
    message: '',
    severity: 'error',
};

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        showSnackbar: (
            state,
            action: PayloadAction<{ message: string; severity?: SnackbarSeverity }>
        ) => ({
            ...state,
            open: true,
            message: action.payload.message,
            severity: action.payload.severity ?? 'error',
        }),
        closeSnackbar: (state) => ({
            ...state,
            open: false,
        }),
    },
});

export const { showSnackbar, closeSnackbar } = snackbarSlice.actions
export default snackbarSlice.reducer;
